export const CHECKOUT_URL = 'https://www.orbitdigital.store/cart/48960962822283:1';
export interface Tomo {
  number: number;
  tag: string;
  title: string;
  description: string;
}
export const tomos: Tomo[] = [{
  number: 1,
  tag: "Tomo",
  title: 'Diagnóstico de Crisis',
  description: 'Dónde se rompió el vínculo y por qué. El mapa exacto de tu situación antes de intervenir.'
}, {
  number: 2,
  tag: "Tomo",
  title: 'El idioma del adolescente',
  description: 'Cómo hablarle sin activar su defensa. El tomo que más padres señalan como el quiebre.'
}, {
  number: 3,
  tag: "Tomo",
  title: 'Contrato de Soberanía Compartida',
  description: 'Límites que se negocian, no se imponen. Y que por eso se sostienen en el tiempo.'
}, {
  number: 4,
  tag: "Tomo",
  title: 'Desintoxicación de dopamina',
  description: 'Bajar pantallas sin declarar la guerra. Protocolo progresivo de 21 días.'
}, {
  number: 5,
  tag: "Tomo",
  title: 'Puentes de conexión real',
  description: 'Rituales cortos que reconstruyen confianza sin que parezca una terapia forzada.'
}, {
  number: 6,
  tag: "Tomo",
  title: 'Blindaje y Futuro',
  description: 'Sostener lo logrado, señales de alerta y cuándo derivar a un profesional. Protocolo SOS incluido.'
}];
export const tomoIncludes: string[] = ['Teoría de fondo + ciencia real', 'Frases, scripts y protocolos listos', 'Ejercicios prácticos paso a paso', 'Casos reales de familias argentinas', 'Checklists y plantillas descargables', 'Señales de alerta (cuándo buscar profesional)', 'Sistemas probados con +2.000 familias', '100% compatible con familias separadas'];
export interface Bono {
  index: string;
  label: string;
  title: string;
  short: string;
  description: string;
  value: string;
}
export const bonos: Bono[] = [{
  index: '01',
  label: 'Bono 1',
  title: 'Kit SOS Anti-Portazo',
  short: 'Kit SOS Anti-Portazo',
  description: 'Protocolo de emergencia para bajar conflictos en 10 minutos.',
  value: '$8.000'
}, {
  index: '02',
  label: 'Bono 2',
  title: 'Mapa de Frases',
  short: 'Mapa de Frases (40 scripts)',
  description: '40 scripts exactos para hablar sin activar defensa.',
  value: '$10.000'
}, {
  index: '03',
  label: 'Bono 3',
  title: 'Cena Sin Celulares',
  short: 'Cena Sin Celulares',
  description: 'Checklist de preguntas que abren conversación de verdad.',
  value: '$9.000'
}, {
  index: '04',
  label: 'Bono 4',
  title: 'Acuerdo Digital Familiar',
  short: 'Acuerdo Digital Familiar',
  description: 'Plantilla de contrato para descargar y negociar juntos.',
  value: '$8.000'
}, {
  index: '05',
  label: 'Bono 5',
  title: 'Tracker Microvictorias',
  short: 'Tracker Microvictorias',
  description: 'Medidor visual de pequeños avances en el vínculo (30 días).',
  value: '$9.000'
}, {
  index: '06',
  label: 'Bono 6',
  title: 'Guía SOS',
  short: 'Guía SOS',
  description: 'Calendario paso a paso para implementar todo el sistema.',
  value: '$9.000'
}];
export interface Plan {
  id: string;
  name: string;
  featured: boolean;
  contents: string;
  idealFor: string;
  listPrice: string;
  price: string;
  cta: string;
  checkoutUrl: string;
  perks: string[];
  extra?: string;
}
export const plans: Plan[] = [{
  id: 'megapack',
  name: "Reconexión",
  featured: false,
  contents: '6 Tomos + 6 Bonos',
  idealFor: 'Pre-adolescentes y adolescentes',
  listPrice: '$51.000',
  price: "$19.990 ARS",
  cta: 'Quiero el MegaPack',
  checkoutUrl: 'https://www.orbitdigital.store/cart/48960962822283:1',
  perks: ['6 tomos completos (360+ páginas)', '6 bonos estratégicos incluidos', 'Acceso inmediato y de por vida']
}, {
  id: 'metodo12',
  name: "+ Método 12 Semanas",
  featured: true,
  contents: '6 Tomos + 6 Bonos + Plan personalizado guiado',
  idealFor: 'Padres que quieren implementación guiada',
  listPrice: '$69.000',
  price: "$27.990 ARS",
  cta: 'Quiero el MegaPack + Método',
  checkoutUrl: 'https://www.orbitdigital.store/cart/48960991461515:1',
  perks: ['Todo lo del MegaPack Reconexión', 'Hoja de Ruta de 12 Semanas personalizada', '2 llamadas de estrategia (semanas 4 y 9)', 'Garantía acelerada: semana 4 o reembolso']
}];